<template>
  <div class="event">
    <div class="content">
      <div class="summary">
        {{item.title}}
      </div>
      <div class="extra text" v-html="descriptionWithNewlines"/>
    </div>
  </div>
</template>


<script>
export default {
  props: ['item'],
  
  computed: {
    descriptionWithNewlines(){
      return this.item.description.replace(/\n/g, '<br/>')
    }
  }
}
</script>



// WEBPACK FOOTER //
// news.vue?2fbca10c